import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import ConfirmBorrador from 'App/Emitidos/ConfirmBorrador';
import { FoliosContext } from "App/Administracion/Folios/store";
import { LayoutContext } from "App/Layout/store";
import ConvertXML from 'xml-js';
import _ from 'underscore';
import { CrearDTE } from 'App/Emitidos/Actions';

const styles = theme => ({
    table: {
        marginTop: 30,
    },
    gridContainer: {
        paddingRight: 30,
        marginTop: "0.1px"
    },
    borderRed: {
        borderStyle: "solid",
        marginTop: "0.1px",
        padding: 10,
        borderColor: "red"
    },
    labelPaddingTop: {
        paddingTop: "10px"
    }
});

function CargarArchivo(props) {
    const [archivosXML, setArchivosXML] = useState({});
    const [archivosJson, setArchivosJson] = useState({});
    const [openConfirmBorrador, setOpenConfirmBorrador] = useState(false);

    const { classes } = props;

    const layoutContext = useContext(LayoutContext);

    function QuitarTipoDoc(index) {
        var JsonFiles = archivosJson;
        JsonFiles.XML.DTE.splice(index, 1);
        var XMLFiles = ConvertXML.json2xml(JsonFiles, { compact: true, ignoreComment: true, spaces: 4 });
        setArchivosXML(XMLFiles);
        setArchivosJson(JsonFiles);
    }

    const handleToggleModal = () => {
        layoutContext.dispatch({ type: "toggleCargaArchivoVenta"});
        setArchivosXML({});
        setArchivosJson({});
    }

    function onFileInputChange(event) {
        event.preventDefault();
        const _validFileExtensions = [".xml", ".txt"];
        var fileInput = event.target;
        var file = fileInput.files[0];

        if (file != null) {
            var sFileName = file.name;
            var blnValid = false;
            for (var j = 0; j < _validFileExtensions.length; j++) {
                var sCurExtension = _validFileExtensions[j];
                if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }

            if (!blnValid) {
                alert("Sólo se aceptan archivos de tipo XML o texto");
                return false;
            }

            var reader = new FileReader();

            // Closure to capture the file information.
            reader.onload = function (e) {
                // Render thumbnail.
                var xml = e.target.result;
                var json = ConvertXML.xml2js(xml, { compact: true });

                var addFile = true;

                //XML => DTE => Documento<[]> => Encabezado => IdDoc//Receptor//Totales

                if (addFile) {
                    setArchivosJson(json);
                    setArchivosXML(xml);

                    fileInput.value = "";
                } else {
                    alert("Documento previamente ingresado");
                    fileInput.value = "";
                }
            };

            reader.readAsText(file);
        }
    }

    function GuardarVenta(borrador) {
        CrearDTE(archivosXML, true, borrador, (dtes) => {
            var errores = "Se han detectado errores en los siguientes documentos: ";
            if(_.where(dtes.DTE, { Error }).length > 0) {
                errores = dtes.DTE.reduce((s, i) => {
                    return s + "\n" + i.Id + " ~ Folio : "+ i.Folio
                }, errores);
                alert(errores);
            } else {
                alert("DTEs creados con éxito");
                layoutContext.dispatch({ type: "toggleCargaArchivoVenta" });
                toggleConfirmBorrador();
            }
        }, (error) => {
            console.log(error)
        });
    }

    function toggleConfirmBorrador() {
        setOpenConfirmBorrador(!openConfirmBorrador);
    }

    const content = (
        <Grid container direction="column">
            <ConfirmBorrador open={openConfirmBorrador} guardarDTE={GuardarVenta} handleClose={toggleConfirmBorrador} />
            <Grid item xs={12} sm>
                <Button variant="contained"
                    containerElement='label' // <-- Just add me!
                    label='Archivo DTE'>
                    <input onChange={onFileInputChange} type="file" />
                </Button>
            </Grid>
            <Grid item xs={12} sm>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Tipo de documento</TableCell>
                            <TableCell>Rut Receptor</TableCell>
                            <TableCell>Nombre Receptor</TableCell>
                            <TableCell>Fecha de emisión</TableCell>
                            <TableCell numeric>Neto</TableCell>
                            <TableCell numeric>IVA</TableCell>
                            <TableCell numeric>Total</TableCell>
                            <TableCell>Quitar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {archivosJson.XML ? (Array.isArray(archivosJson.XML.DTE) ? archivosJson.XML.DTE : [archivosJson.XML.DTE]).map((dte, ix) => {
                            var deleteButton = (index) => {
                                return (
                                    <Button onClick={() => { QuitarTipoDoc(index) }}><Icon>remove_circle</Icon></Button>
                                )
                            };
                            return (
                                <TableRow key={ix}>
                                    <TableCell>{(_.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(dte.Documento.Encabezado.IdDoc.TipoDTE._text) }) || { Nombre: "" }).Nombre}</TableCell>
                                    <TableCell>{dte.Documento.Encabezado.Receptor.RUTRecep._text}</TableCell>
                                    <TableCell>{dte.Documento.Encabezado.Receptor.RznSocRecep._text}</TableCell>
                                    <TableCell>{dte.Documento.Encabezado.IdDoc.FchEmis._text}</TableCell>
                                    <TableCell numeric>{dte.Documento.Encabezado.Totales.MntNeto ? dte.Documento.Encabezado.Totales.MntNeto._text : "-"}</TableCell>
                                    <TableCell numeric>{dte.Documento.Encabezado.Totales.IVA ? dte.Documento.Encabezado.Totales.IVA._text : "-"}</TableCell>
                                    <TableCell numeric>{(!dte.Documento.Encabezado.Totales.MntNeto || !dte.Documento.Encabezado.Totales.IVA) ? (dte.Documento.Encabezado.Totales.MntTotal ? dte.Documento.Encabezado.Totales.MntTotal._text : "-") : (parseInt(dte.Documento.Encabezado.Totales.MntNeto._text) + parseInt(dte.Documento.Encabezado.Totales.IVA._text))}</TableCell>
                                    <TableCell>{deleteButton(ix)}</TableCell>
                                </TableRow>
                            );
                        })
                            :
                            null
                        }
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    );
    const footer = (
        <DialogActions>
            <Button onClick={handleToggleModal} color="secondary" autoFocus>
                Cancelar
            </Button>
            <Button onClick={toggleConfirmBorrador} color="primary" autoFocus>
                Aceptar
            </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={layoutContext.state.openCargaArchivoVenta} onClose={handleToggleModal} closeButton title={"Nueva Venta"} content={content} footer={footer} fullWidth fullHeight size="lg" />
        </div>
    );
}

export default withStyles(styles)(React.memo(CargarArchivo));